import token, { tokenToVars } from '../token';
import Spin from './spin';

export { Spin };
export default tokenToVars(Spin, token);
